import * as Scrivito from "scrivito";
import { getRubyTenantVersion } from "./filterByTenant";
import { linkHostname } from "./getTenantSettings";

function isBlobType(obj: Scrivito.Obj | null) {
  if (!obj) return false;
  const blobTypes = ["Document", "Image", "VideoVimeo"];
  return blobTypes.includes(obj.objClass());
}

// if needed, it replaces Scrivito link and navigates to its Ruby site equivalent
export const getPageLink = (link: Scrivito.Link | Scrivito.Obj) => {
  if (!link) {
    console.error("link parameter is required");
    return null;
  }

  if (
    !(link instanceof Scrivito.Link) &&
    !link?.get("isJSSiteReady") &&
    !isBlobType(link)
  ) {
    return new Scrivito.Link({
      url: `https://${getRubyTenantVersion() as string}/${link.id()}`,
    });
  }

  if (
    link instanceof Scrivito.Link &&
    link.url()?.includes(linkHostname()) &&
    !link.isInternal()
  ) {
    return new Scrivito.Link({
      url: link
        .url()
        ?.replace(linkHostname(), getRubyTenantVersion() as string),
    });
  }

  const linkObj = link instanceof Scrivito.Link ? link.obj() : null;

  if (
    link instanceof Scrivito.Link &&
    link.isInternal() &&
    linkObj &&
    !linkObj?.get("isJSSiteReady") &&
    !isBlobType(linkObj)
  ) {
    return new Scrivito.Link({
      url: `https://${getRubyTenantVersion()}/${linkObj.id()}`,
    });
  }
  return link;
};
